import React from 'react';
import { StepProvider } from './stepContext';

const AppProvider: React.FC = ({ children }) => {
  return <StepProvider>{children}</StepProvider>;
};

export default AppProvider;
